import React from 'react';
import Moment from 'react-moment';

interface Props {
	value: string;
}

const DateFormat: React.FC<Props> = ({ value }) => {
    return (
        <Moment
            format="DD/MM/YYYY"
        >
            {value}
        </Moment>
    );
};

export default DateFormat;
